// extracted by mini-css-extract-plugin
export default {"footerBg":"r-z","footerTopLinks":"s-z","footerFeedback":"t-z","footerSocial":"u-z","footerLegalLinks":"v-z","footerIconCards":"w-z","footerBotCopy":"x-z","screenReadersOnly":"y-z"};